/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown>, currency: NonNullable<unknown>, number: NonNullable<unknown> }} Purchase_Confirm_GeneralInputs */

const en_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.price} ${i?.currency} to exchange for ${i?.number} Coins?`)
};

const ar_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هل تريد استخدام ${i?.price} ${i?.currency} لاستبدالها بـ ${i?.number} عملة؟`)
};

const de_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} ${i?.currency} gegen ${i?.number} Münzen eintauschen?`)
};

const es_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cambiar ${i?.price} ${i?.currency} por ${i?.number} Monedas?`)
};

const fr_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échanger ${i?.price} ${i?.currency} contre ${i?.number} Pièces ?`)
};

const it_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scambiare ${i?.price} ${i?.currency} con ${i?.number} Monete?`)
};

const ja_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price}${i?.currency}を使って${i?.number}コインと交換しますか？`)
};

const ko_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} ${i?.currency}을(를) ${i?.number} 코인으로 교환할까요?`)
};

const pt_br_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Trocar ${i?.price} ${i?.currency} por ${i?.number} Moedas?`)
};

const ru_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Обменять ${i?.price} ${i?.currency} на ${i?.number} монет?`)
};

const th_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ใช้ ${i?.price} ${i?.currency} แลกเป็น ${i?.number} เหรียญไหม?`)
};

const tr_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} ${i?.currency}, ${i?.number} Jeton ile takas edilsin mi?`)
};

const zh_cn_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} ${i?.currency} 兑换 ${i?.number} 金币？`)
};

const zh_tw_purchase_confirm_general = /** @type {(inputs: Purchase_Confirm_GeneralInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`用 ${i?.price} ${i?.currency} 兌換 ${i?.number} 金幣？`)
};

/**
* | output |
* | --- |
* | "Use {price} {currency} to exchange for {number} Coins?" |
*
* @param {Purchase_Confirm_GeneralInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const purchase_confirm_general = /** @type {((inputs: Purchase_Confirm_GeneralInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Purchase_Confirm_GeneralInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_purchase_confirm_general(inputs)
	if (locale === "ar") return ar_purchase_confirm_general(inputs)
	if (locale === "de") return de_purchase_confirm_general(inputs)
	if (locale === "es") return es_purchase_confirm_general(inputs)
	if (locale === "fr") return fr_purchase_confirm_general(inputs)
	if (locale === "it") return it_purchase_confirm_general(inputs)
	if (locale === "ja") return ja_purchase_confirm_general(inputs)
	if (locale === "ko") return ko_purchase_confirm_general(inputs)
	if (locale === "pt_br") return pt_br_purchase_confirm_general(inputs)
	if (locale === "ru") return ru_purchase_confirm_general(inputs)
	if (locale === "th") return th_purchase_confirm_general(inputs)
	if (locale === "tr") return tr_purchase_confirm_general(inputs)
	if (locale === "zh_cn") return zh_cn_purchase_confirm_general(inputs)
	return zh_tw_purchase_confirm_general(inputs)
});